import React, { forwardRef } from 'react';
import PartnerList from '../../Common/PartnerList/PartnerList';
import './IndustryExpertsDirectory.scss';

const IndustryExpertsDirectory = forwardRef(({...props}, ref) => {
  return (
    <>
      <div className="industry-experts-directory" ref={ref}>
        <div className="industry-experts-directory-header">
          <div className="heading">Industry Experts Directory</div>
          <div className="sub-heading">
            Browse the Directory for vetted Experts and solutions to address any and all small business pain points.
          </div>
        </div>
        <PartnerList 
          limit={12}
          searchTitle="search our partners..."
          isIndustryExperts={true} 
          cls="industry-experts-partner-list" 
        />
      </div>
    </>
  )
});

export default IndustryExpertsDirectory; 